import { NotFound } from '@/components/partials/NotFound';

const IndexPage = () => {
  return <NotFound />;
};

export default IndexPage;
